import { ImgHTMLAttributes, ReactEventHandler } from 'react'

type Props = {
  fallback: string,
} & ImgHTMLAttributes<HTMLImageElement>

export const Image = ({fallback, alt = '', onError, ...restProps}: Props) => {
  const handleError: ReactEventHandler<HTMLImageElement> = (e) => {
    const img = e.currentTarget;
    img.onerror = null;  // prevents looping
    img.src = fallback;
    onError?.(e);
  };

  return (
    <img
      {...restProps}
      onError={handleError}
      alt={alt}
    />
  )
}
